<template>
  <div class="user-management">
    <el-card shadow="never" class="animate__animated animate__fadeInUp">
      <div class="filter-card">
        <div style="display:flex;flex-wrap:wrap;align-items:center;justify-content:space-between;gap:10px;">
          <div style="display:flex;flex-wrap:wrap;align-items:center;gap:10px;">
            <el-input
              v-model="searchUsername"
              placeholder="搜索用户名"
              prefix-icon="el-icon-search"
              clearable
              @keyup.enter.native="handleSearch"
              style="width:160px;"
            ></el-input>
            <el-input
              v-model="searchInviteCode"
              placeholder="搜索邀请码"
              prefix-icon="el-icon-collection-tag"
              clearable
              @keyup.enter.native="handleSearch"
              style="width:160px;"
            ></el-input>
            <el-input
              v-model="searchCaptainId"
              placeholder="用户ID"
              prefix-icon="el-icon-user-solid"
              clearable
              @keyup.enter.native="handleSearch"
              style="width:130px;"
            ></el-input>
            <el-date-picker
              v-model="searchDateRange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              :clearable="true"
              style="width:300px;"
            ></el-date-picker>
            <el-button
              type="primary"
              icon="el-icon-search"
              @click="handleSearch"
            >搜索</el-button>
          </div>
          <div style="display:flex;flex-wrap:wrap;gap:6px;">
            <el-button
              type="primary"
              icon="el-icon-refresh"
              @click="refreshList"
            >刷新列表</el-button>
          </div>
        </div>
      </div>

      <div v-if="error" class="error">{{ error }}</div>
      <el-empty
        v-else-if="!loading && users.length === 0"
        description="暂无用户数据"
      />

      <div v-else>
        <!-- 用户表格 -->
        <el-table
          :data="users"
          border
          stripe
          v-loading="loading"
          element-loading-text="正在加载用户数据..."
          class="animate__animated animate__fadeIn"
        >
          <el-table-column prop="id" label="ID" width="80" align="center" />
          <el-table-column prop="username" label="用户名" min-width="150" show-overflow-tooltip />
          <el-table-column prop="parentId" label="上级用户ID" width="150" align="center">
            <template slot-scope="scope">
              {{ scope.row.parentId || '-' }}
            </template>
          </el-table-column>
          <el-table-column prop="inviteCode" label="邀请码" width="150" align="center">
            <template slot-scope="scope">
              {{ scope.row.inviteCode || '-' }}
            </template>
          </el-table-column>
          <el-table-column prop="status" label="账号状态" width="100" align="center">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.status === 0" type="success" size="small">正常</el-tag>
              <el-tag v-else-if="scope.row.status === 1" type="danger" size="small">封禁</el-tag>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="isCaptain" label="是否为团长" width="110" align="center">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.isCaptain === 1" type="success" size="small">是</el-tag>
              <el-tag v-else-if="scope.row.isCaptain === 0" type="info" size="small">否</el-tag>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="createdAt" label="注册时间" width="180" align="center">
            <template slot-scope="scope">
              {{ formatDate(scope.row.createdAt) }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="520" align="center">
            <template slot-scope="scope">
              <div style="display: flex; justify-content: center; align-items: center; gap: 6px; flex-wrap: wrap;">
                <el-button
                  size="mini"
                  type="primary"
                  icon="el-icon-wallet"
                  @click="handleCheckBalance(scope.row)"
                >查询余额</el-button>
                <el-button
                  size="mini"
                  type="info"
                  icon="el-icon-tickets"
                  @click="handleViewFlow(scope.row)"
                >查看流水</el-button>
                <el-button
                  size="mini"
                  :type="scope.row.status === 0 ? 'danger' : 'success'"
                  :icon="scope.row.status === 0 ? 'el-icon-close' : 'el-icon-check'"
                  @click="handleToggleStatus(scope.row)"
                >{{ scope.row.status === 0 ? '禁用' : '启用' }}</el-button>
                <el-button
                  size="mini"
                  type="success"
                  icon="el-icon-edit"
                  @click="handleEditUser(scope.row)"
                >编辑</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pagination-container">
          <el-pagination
            background
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="pagination.pageNum"
            :page-size="pagination.pageSize"
            :page-sizes="[5, 10, 20, 50]"
            :total="pagination.total"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          />
        </div>
      </div>
    </el-card>

    <!-- 新增/编辑用户对话框 -->
    <el-dialog
      :title="'编辑用户'"
      :visible.sync="addDialogVisible"
      width="500px"
      center
    >
      <el-form :model="currentUser" :rules="userRules" ref="userForm" label-width="120px">
        <el-form-item label="用户名" prop="username">
          <el-input v-model="currentUser.username" :placeholder="isEdit ? '请输入用户名' : '请输入用户名'"></el-input>
        </el-form-item>
        <el-form-item label="邀请码" prop="inviteCode">
          <el-input v-model="currentUser.inviteCode" placeholder="请输入邀请码（可选）"></el-input>
        </el-form-item>
        <el-form-item label="上级用户 ID" prop="parentId">
          <el-input v-model="currentUser.parentId" type="number" placeholder="请输入上级用户 ID"></el-input>
        </el-form-item>
        <el-form-item label="账号状态" prop="status">
          <el-radio-group v-model="currentUser.status">
            <el-radio :label="0">正常</el-radio>s
            <el-radio :label="1">封禁</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否为团长" prop="isCaptain">
          <el-radio-group v-model="currentUser.isCaptain">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmAddUser" :loading="submitLoading">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 查询余额对话框 -->
    <el-dialog
      title="用户余额详情"
      :visible.sync="balanceDialogVisible"
      width="500px"
      center
    >
      <div v-loading="balanceLoading">
        <el-form label-width="120px" :model="userBalance" class="balance-form">
          <el-form-item label="用户 ID:">
            <span>{{ userBalance.id || '-' }}</span>
          </el-form-item>
          <el-form-item label="用户名:">
            <span>{{ userBalance.username || '-' }}</span>
          </el-form-item>
          <el-form-item label="当前金币余额:">
            <span>{{ userBalance.coinBalance || 0 }}</span>
          </el-form-item>
          <el-form-item label="累计获得金币:">
            <span>{{ userBalance.totalEarned || 0 }}</span>
          </el-form-item>
          <el-form-item label="累计提现扣除:">
            <span>{{ userBalance.totalWithdrawn || 0 }}</span>
          </el-form-item>
          <el-form-item label="更新时间:">
            <span>{{ formatDate(userBalance.updatedAt) }}</span>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="warning" icon="el-icon-coin" @click="handleAdjustCoinFromBalance">调整金币</el-button>
        <el-button @click="balanceDialogVisible = false">关 闭</el-button>
      </div>
    </el-dialog>

    <!-- 调整金币对话框 -->
    <el-dialog
      title="后台调整用户金币"
      :visible.sync="adjustCoinDialogVisible"
      width="450px"
      center
    >
      <el-form :model="adjustCoinForm" :rules="adjustCoinRules" ref="adjustCoinForm" label-width="100px">
        <el-form-item label="用户名" prop="username">
          <el-input v-model="adjustCoinForm.username" disabled></el-input>
        </el-form-item>
        <el-form-item label="调整金额" prop="amount">
          <el-input-number
            v-model="adjustCoinForm.amount"
            :precision="0"
            :min="-999999"
            :max="999999"
            placeholder="正数加金币，负数扣金币"
            style="width:100%"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="调整原因" prop="description">
          <el-input
            v-model="adjustCoinForm.description"
            type="textarea"
            :rows="2"
            placeholder="选填，不填将自动生成"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="adjustCoinDialogVisible = false">取 消</el-button>
        <el-button type="warning" @click="confirmAdjustCoin" :loading="adjustCoinLoading">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 查看下级用户对话框 -->
    <el-dialog
      :title="'团长【' + currentCaptain.username + '】的下级用户'"
      :visible.sync="subordinatesDialogVisible"
      width="800px"
      center
    >
      <el-table
        :data="subordinates"
        border
        stripe
        v-loading="subordinatesLoading"
        element-loading-text="正在加载下级用户..."
        max-height="400"
      >
        <el-table-column prop="id" label="ID" width="80" align="center" />
        <el-table-column prop="username" label="用户名" min-width="150" show-overflow-tooltip />
        <el-table-column prop="parentId" label="上级ID" width="100" align="center" />
        <el-table-column prop="isCaptain" label="团长" width="80" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.isCaptain === 1" type="success" size="mini">是</el-tag>
            <el-tag v-else type="info" size="mini">否</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" width="80" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status === 0" type="success" size="mini">正常</el-tag>
            <el-tag v-else-if="scope.row.status === 1" type="danger" size="mini">封禁</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="inviteCode" label="邀请码" width="120" align="center" />
        <el-table-column prop="createdAt" label="注册时间" width="160" align="center">
          <template slot-scope="scope">
            {{ formatDate(scope.row.createdAt) }}
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="subordinatesDialogVisible = false">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { request } from '@/utils/http'

export default {
  name: 'UserManagement',
  data() {
    return {
      users: [],
      loading: false,
      error: '',
      searchUsername: '',
      searchInviteCode: '',
      searchCaptainId: '',
      searchDateRange: [],
      pagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      addDialogVisible: false,
      isEdit: false,
      currentUser: {},
      submitLoading: false,
      userRules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          { min: 3, max: 20, message: '长度在 3 到 20 个字符', trigger: 'blur' }
        ]
      },
      balanceDialogVisible: false,
      balanceLoading: false,
      userBalance: {},
      // 调整金币
      adjustCoinDialogVisible: false,
      adjustCoinLoading: false,
      adjustCoinForm: {
        username: '',
        amount: 0,
        description: ''
      },
      adjustCoinRules: {
        amount: [
          { required: true, message: '请输入调整金额', trigger: 'blur' },
          { type: 'number', message: '必须为数字', trigger: 'blur' }
        ]
      },
      // 查看下级
      subordinatesDialogVisible: false,
      subordinatesLoading: false,
      subordinates: [],
      currentCaptain: { username: '' }
    }
  },
  async mounted() {
    await this.fetchUsers()
  },
  methods: {
    async fetchUsers() {
      this.loading = true
      this.error = ''
      
      try {
        // 构建查询参数
        let params = new URLSearchParams();
        params.append('pageNum', this.pagination.pageNum);
        params.append('pageSize', this.pagination.pageSize);
        
        // 添加用户名筛选参数
        if (this.searchUsername) {
          params.append('username', this.searchUsername);
        }

        // 添加邀请码筛选参数
        if (this.searchInviteCode) {
          params.append('inviteCode', this.searchInviteCode);
        }

        // 添加团长ID筛选参数
        if (this.searchCaptainId) {
          params.append('captainId', this.searchCaptainId);
        }

        // 添加注册时间范围筛选
        if (this.searchDateRange && this.searchDateRange.length === 2) {
          params.append('startDate', this.searchDateRange[0]);
          params.append('endDate', this.searchDateRange[1]);
        }
        
        const queryString = params.toString();
        const response = await request(`/admin/users/page?${queryString}`)
        this.users = response.data.records
        this.pagination.total = response.data.total
        
      } catch (error) {
        console.error('获取用户列表失败:', error)
        this.error = error.message || '获取用户列表失败'
      } finally {
        this.loading = false
      }
    },
    
    handleCurrentChange(pageNum) {
      this.pagination.pageNum = pageNum
      this.fetchUsers()
    },
    
    handleSizeChange(pageSize) {
      this.pagination.pageSize = pageSize
      this.pagination.pageNum = 1
      this.fetchUsers()
    },
    
    handleSearch() {
      this.pagination.pageNum = 1
      this.fetchUsers()
    },
    
    refreshList() {
      this.searchUsername = ''
      this.searchInviteCode = ''
      this.searchCaptainId = ''
      this.searchDateRange = []
      this.pagination.pageNum = 1
      this.fetchUsers()
    },
    
    handleEditUser(user) {
      this.isEdit = true
      this.currentUser = {
        id: user.id,
        username: user.username,
        inviteCode: user.inviteCode || '',
        parentId: user.parentId,
        status: user.status,
        isCaptain: user.isCaptain !== undefined ? user.isCaptain : 0
      }
      this.addDialogVisible = true
      this.$nextTick(() => {
        this.$refs.userForm && this.$refs.userForm.clearValidate()
      })
    },
    
    async confirmAddUser() {
      if (!this.$refs.userForm) return
      
      await this.$refs.userForm.validate(async (valid) => {
        if (!valid) return
        
        this.submitLoading = true
        try {
          let response
          if (this.isEdit) {
            response = await request('/admin/users/update', {
              method: 'PUT',
              body: JSON.stringify({
                id: this.currentUser.id,
                username: this.currentUser.username,
                inviteCode: this.currentUser.inviteCode,
                parentId: this.currentUser.parentId,
                status: this.currentUser.status,
                isCaptain: this.currentUser.isCaptain
              })
            })
          } else {
            response = await request('/admin/users/add', {
              method: 'POST',
              body: JSON.stringify({
                username: this.currentUser.username,
                inviteCode: this.currentUser.inviteCode,
                parentId: this.currentUser.parentId,
                status: this.currentUser.status,
                isCaptain: this.currentUser.isCaptain
              })
            })
          }
          
          if (response && response.code === 200) {
            this.$message.success(response.msg || '修改成功')
            this.addDialogVisible = false
            this.fetchUsers()
          } else {
            throw new Error(response.msg || '修改失败')
          }
        } catch (error) {
          this.$message.error(error.message || '修改失败')
        } finally {
          this.submitLoading = false
        }
      })
    },
    
    async handleToggleStatus(user) {
      const actionText = user.status === 0 ? '禁用' : '启用'
      
      try {
        const response = await request(`/admin/users/${user.id}/status?status=${user.status}`, {
          method: 'PUT'
        })
        
        if (response && response.code === 200) {
          this.$message.success(response.msg || `${actionText}成功`)
          user.status = user.status === 0 ? 1 : 0
        } else {
          throw new Error(response.msg || `${actionText}失败`)
        }
      } catch (error) {
        this.$message.error(error.message || `${actionText}失败`)
      }
    },
    
    async handleCheckBalance(user) {
      this.balanceDialogVisible = true
      this.balanceLoading = true
      this.userBalance = {}
      try {
        const response = await request(`/admin/user-balance/get-balance?username=${encodeURIComponent(user.username)}`)
        if (response && response.code === 200) {
          this.userBalance = response.data
        } else {
          this.$message.error(response.msg || '获取余额失败')
        }
      } catch (error) {
        console.error('获取余额失败:', error)
        this.$message.error(error.message || '获取余额失败')
      } finally {
        this.balanceLoading = false
      }
    },
    
    handleViewFlow(user) {
      this.$router.push({
        path: '/coin-flow',
        query: { username: user.username }
      })
    },

    handleAdjustCoinDialog(user) {
      this.adjustCoinForm = {
        username: user.username,
        amount: 0,
        description: ''
      }
      this.adjustCoinDialogVisible = true
      this.$nextTick(() => {
        this.$refs.adjustCoinForm && this.$refs.adjustCoinForm.clearValidate()
      })
    },

    handleAdjustCoinFromBalance() {
      this.balanceDialogVisible = false
      this.adjustCoinForm = {
        username: this.userBalance.username || '',
        amount: 0,
        description: ''
      }
      this.adjustCoinDialogVisible = true
      this.$nextTick(() => {
        this.$refs.adjustCoinForm && this.$refs.adjustCoinForm.clearValidate()
      })
    },

    handleAdjustCoinFromEdit() {
      this.addDialogVisible = false
      this.adjustCoinForm = {
        username: this.currentUser.username || '',
        amount: 0,
        description: ''
      }
      this.adjustCoinDialogVisible = true
      this.$nextTick(() => {
        this.$refs.adjustCoinForm && this.$refs.adjustCoinForm.clearValidate()
      })
    },

    async confirmAdjustCoin() {
      if (!this.$refs.adjustCoinForm) return
      await this.$refs.adjustCoinForm.validate(async (valid) => {
        if (!valid) return
        this.adjustCoinLoading = true
        try {
          const params = new URLSearchParams()
          params.append('username', this.adjustCoinForm.username)
          params.append('amount', this.adjustCoinForm.amount)
          if (this.adjustCoinForm.description) {
            params.append('description', this.adjustCoinForm.description)
          }
          const response = await request('/admin/users/adjust-coin', {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: params.toString()
          })
          if (response && response.code === 200) {
            this.$message.success(response.msg || '调整成功')
            this.adjustCoinDialogVisible = false
            this.fetchUsers()
          } else {
            throw new Error(response.msg || '调整失败')
          }
        } catch (error) {
          this.$message.error(error.message || '调整失败')
        } finally {
          this.adjustCoinLoading = false
        }
      })
    },

    async handleViewSubordinates(user) {
      this.currentCaptain = user
      this.subordinatesDialogVisible = true
      this.subordinatesLoading = true
      this.subordinates = []
      try {
        const response = await request(`/admin/users/${user.id}/subordinates`)
        if (response && response.code === 200) {
          this.subordinates = response.data || []
        } else {
          this.$message.error(response.msg || '获取下级用户失败')
        }
      } catch (error) {
        console.error('获取下级用户失败:', error)
        this.$message.error(error.message || '获取下级用户失败')
      } finally {
        this.subordinatesLoading = false
      }
    },

    formatDate(dateString) {
      if (!dateString) return '-'
      const date = new Date(dateString)
      return date.toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      })
    }
  }
}
</script>

<style scoped>
.user-management {
}

/* 日期范围选择器 - 确保"至"不被遮挡 */
.user-management ::v-deep .el-date-range-picker {
  min-width: 600px;
}
.user-management ::v-deep .el-range-editor {
  min-width: 300px;
}
.user-management ::v-deep .el-range-separator {
  width: 10%;
  padding: 0 8px;
  text-align: center;
}

.filter-card {
  margin-bottom: 20px;
}

.error {
  color: #f87171;
  padding: 10px;
  background-color: rgba(239, 68, 68, 0.15);
  border: 1px solid rgba(239, 68, 68, 0.3);
  border-radius: 4px;
  margin-bottom: 20px;
}

.el-table {
  margin-bottom: 20px;
}

.pagination-container {
  display: flex;
  justify-content: center;
}

.dialog-footer {
  text-align: right;
}

.balance-form .el-form-item {
  margin-bottom: 15px;
  border-bottom: 1px dashed #ebeef5;
  padding-bottom: 5px;
}

.balance-form .el-form-item:last-child {
  border-bottom: none;
}
</style>
